// hooks/permissions.ts
import { useCallback, useContext, useEffect, useState } from "react";
import { AuthContext } from "../contexts/user-context/user-context";
import { API_ENDPOINT } from "../configurations/global.config";
import axios from "axios";
import { useSnackBar } from "../contexts/snackbar";
import { Permission } from "../interfaces/common/permissions";

export const usePermissions = ({ autoFetch = true } = {}) => {
  const { config, user } = useContext(AuthContext);
  const { showMessage } = useSnackBar();
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchPermissions = useCallback(async () => {
    if (!user) return;
    try {
      setIsLoading(true);
      const res = await axios.get<Permission[]>(`${API_ENDPOINT}/v1/permissions/`, config);
      setPermissions(res.data);
    } catch (err) {
      console.error("Failed to fetch permissions", err);
      showMessage("Failed to fetch permissions", "error");
    } finally {
      setIsLoading(false);
    }
  }, [config, user]);

  useEffect(() => {
    if (autoFetch && user) {
      fetchPermissions();
    }
  }, [autoFetch, user, fetchPermissions]);

  return { permissions, fetchPermissions, isLoading };
};
